import stoneService from '@services/magento/stone.service';

import { LocationInterface } from '@stone/interfaces';

export async function fetchLocationsApi(params: any = {}): Promise<{ items: LocationInterface[]; totalCount: number }> {
  const response = await stoneService.getStoneLocations(params);
  return {
    items: response.items || [],
    totalCount: response.total_count || 0,
  };
}

export async function saveLocationApi(data: LocationInterface) {
  return stoneService.saveStoneLocation(data);
}

export async function deleteLocationApi(id: number) {
  return stoneService.deleteStoneLocation(id);
}
